import * as React from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { Input } from "./input";
import { cn } from "@/lib/utils";

// The ONE password field in the app. Reveal state is local, so it starts
// hidden on every mount and is never carried between mounts or fields.
const PasswordInput = React.forwardRef(({ className, ...props }, ref) => {
  const [visible, setVisible] = React.useState(false);
  const testId = props["data-testid"];

  return (
    <div className="relative">
      <Input
        ref={ref}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        {...props}
        type={visible ? "text" : "password"}
        className={cn("pr-11", className)}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        title={visible ? "Hide password" : "Show password"}
        data-testid={testId ? `${testId}-toggle` : "password-visibility-toggle"}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/50 focus-visible:text-foreground"
      >
        {visible ? <EyeSlash size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
